import { z } from "zod";
import { DTOFigmaNode, DTOFigmaNodeV2 } from "./figma-nodes";

//
// Read
//

export const DTOElementsGetTypeFilter = z.enum(["FigmaNode"]);

export const DTOElementsGetQuerySchema = z.object({
  types: z.string().transform(val => val.split(",").map(v => DTOElementsGetTypeFilter.parse(v))),
  responseVersion: z.coerce.number().default(1),
});

export const DTOElementsGetOutput = z.object({
  figmaNodes: z.array(DTOFigmaNode).optional(),
});

export const DTOElementsGetOutputV2 = z.object({
  figmaNodes: z.array(DTOFigmaNodeV2).optional(),
});

export type DTOElementsGetOutput = z.infer<typeof DTOElementsGetOutput>;
export type DTOElementsGetOutputV2 = z.infer<typeof DTOElementsGetOutputV2>;
export type DTOElementsGetQueryRaw = z.input<typeof DTOElementsGetQuerySchema>;
export type DTOElementsGetQueryParsed = z.output<typeof DTOElementsGetQuerySchema>;
export type DTOElementsGetTypeFilter = z.infer<typeof DTOElementsGetTypeFilter>;
